import { render } from "./import-indiamart.vue?vue&type=template&id=38e1dfda&scoped=true"
import script from "./import-indiamart.vue?vue&type=script&lang=js"
export * from "./import-indiamart.vue?vue&type=script&lang=js"

import "./import-indiamart.vue?vue&type=style&index=0&id=38e1dfda&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e1dfda"]])

export default __exports__